import React from 'react'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'

const SlideQuestion = (props) => {
  const {
    QuestionText,
    QuestionType,
    Description,
    QuestionColorFill,
    QuestionFillColor,
    QuestionFontSize,
    QuestionFontFamily,
    QuestionFontWeight,
    QuestionFontStyle
  } = props

  return (
    <div className='smartslide-question-container'>
      {QuestionText !== '' &&
        (QuestionType && QuestionType === 'text' ? (
          <p
            className='smartslide-question-label'
            style={{
              color: QuestionColorFill,
              fontSize:
                QuestionFontSize === 'SMALL'
                  ? SMALL_DESKTOP
                  : QuestionFontSize === 'LARGE'
                  ? LARGE_DESKTOP
                  : MEDIUM_DESKTOP,
              backgroundColor: QuestionFillColor,
              fontFamily: QuestionFontFamily,
              fontStyle: QuestionFontStyle === 'True' ? 'italic' : 'normal',
              fontWeight: QuestionFontWeight === 'True' ? 'bold' : 'normal'
            }}
          >
            {QuestionText}
          </p>
        ) : (
          <div className='slide-description-container'>
            <div
              className='slide-question-image'
              style={{
                fontSize:
                  QuestionFontSize === 'SMALL'
                    ? SMALL_DESKTOP
                    : QuestionFontSize === 'LARGE'
                    ? LARGE_DESKTOP
                    : MEDIUM_DESKTOP
              }}
            >
              <RectangleContent
                contentType={QuestionType}
                contentData={QuestionText}
              />
            </div>
            {Description !== '' && (
              <p
                className='smartslide-question-label'
                style={{
                  color: QuestionColorFill,
                  fontSize:
                    QuestionFontSize === 'SMALL'
                      ? SMALL_DESKTOP
                      : QuestionFontSize === 'LARGE'
                      ? LARGE_DESKTOP
                      : MEDIUM_DESKTOP,
                  backgroundColor: QuestionFillColor,
                  fontFamily: QuestionFontFamily,
                  fontStyle: QuestionFontStyle === 'True' ? 'italic' : 'normal',
                  fontWeight: QuestionFontWeight === 'True' ? 'bold' : 'normal'
                }}
              >
                {Description}
              </p>
            )}
          </div>
        ))}
    </div>
  )
}

export { SlideQuestion }
